import React, {useEffect} from "react";
import {Grid, Typography} from "@mui/material";
import useChallenge3Style from "../../styles/challengeUntold/challenge3";
import kozel_meeet from "../../assets/images/kozel_meet/meet_logo.png";
import clsx from "clsx";
import TeaserFrame2 from "../TeaserFrame2";
import theme from "../../styles/themes/default";
import untold_challenge_step_3 from "../../assets/images/untold/untold_challenge_step_3.png";
import imgZar1 from "../../assets/images/untold/zar1.png";
import imgZar2 from "../../assets/images/untold/zar2.png";
import imgZar3 from "../../assets/images/untold/zar3.png";
import imgZar4 from "../../assets/images/untold/zar4.png";
import imgZar5 from "../../assets/images/untold/zar5.png";
import imgZar6 from "../../assets/images/untold/zar6.png";
import {NavLink} from "react-router-dom";
import {paths} from "../../AppRouters";
import useActivity from "../../hooks/useActivity";

const Challenge3: React.FC = () => {
    const styles = useChallenge3Style();
    const {registerActivity} = useActivity();

    useEffect(() => {
        registerActivity({
            name: 'UNTOLD_CHALLENGE_3',
            payload: {},
            callback: () => {},
        })
    }, []);

    return (
        <Grid container className={styles.container}>
            <Grid item xs={12} lg={6} className={styles.item}>
                <img src={kozel_meeet} alt={'kozel_meeet'} className={styles.logo} style={{maxWidth: '400px'}}/>
            </Grid>
            <Grid item xs={12} lg={6} className={styles.item}>
                <Typography className={styles.motoText}>There's always room for one more!</Typography>
            </Grid>
            <Grid item xs={12} lg={6} className={clsx(styles.item, styles.wrapperTeaserFrame)}>
                <TeaserFrame2
                    title={<Typography className={styles.teaserFrameTitle}>GOATIFUL!</Typography>}
                    backgroundBoxTitle={theme.colors.dark_chocolate}
                    titleMarginTop={'min(-5vh,-5vw)'}
                >
                    <Grid container className={styles.teaserContainer}>
                        <Grid item xs={12} className={styles.teaserItem}>
                            <Typography className={styles.accessText}>You accessed the 3rd CHALLENGE!</Typography>
                        </Grid>
                        <Grid item xs={12} className={styles.teaserItem}>
                            <img src={untold_challenge_step_3} alt={'untold_challenge_step_3'}
                                 className={styles.imgStep}
                                 style={{maxWidth: '240px'}}/>
                        </Grid>
                        <Grid item xs={12} className={styles.teaserItem}>
                            <Typography className={styles.teaserTitle}>BOARDGAME</Typography>
                        </Grid>
                        <Grid item xs={12} className={styles.teaserItem} flexDirection={'column'}>
                            <Typography className={styles.teaserText}>
                                Congratulations! You have reached the last challenge!
                            </Typography>
                            <Typography className={styles.teaserText}>
                                Designate the luckiest team member to roll the dice.
                            </Typography>
                            <Typography className={styles.teaserText}>
                                Depending on which box the dice lands on, you have a new challenge to solve as a team.
                            </Typography>
                            <Typography className={styles.teaserText}>
                                If you miss and the dice ends up off the board, roll the dice again. If you miss a second time, we recommend letting another teammate try their luck :).
                            </Typography>
                            <Typography className={styles.teaserTextSuccess}><b>Good luck!</b></Typography>
                        </Grid>
                        <Grid item xs={12} className={styles.teaserItem}>
                            <Grid container justifyContent={'center'} alignItems={'stretch'} alignContent={'start'}>
                                <Grid item xs={12} lg={6} className={styles.boxZar}>
                                    <img src={imgZar1} alt={'imgZar1'} className={styles.imgZar}/>
                                    <Typography className={styles.zarTitle}>Zarul a căzut pe caseta cu nr. 1</Typography>
                                    <Typography className={styles.zarText}>ȚAPUL Kozel tocmai ce-a trecut pe-aici.Găsește urmele de ȚAP! N-ai cum să le ratezi, sunt maaari!</Typography>
                                </Grid>

                                <Grid item xs={12} lg={6} className={styles.boxZar}>
                                    <img src={imgZar2} alt={'imgZar2'} className={styles.imgZar}/>
                                    <Typography className={styles.zarTitle}>Zarul a căzut pe caseta cu nr. 2</Typography>
                                    <Typography className={styles.zarText}>Rezolvă puzzle-ul cât de rapid poți!</Typography>
                                </Grid>

                                <Grid item xs={12} lg={6} className={styles.boxZar}>
                                    <img src={imgZar3} alt={'imgZar3'} className={styles.imgZar}/>
                                    <Typography className={styles.zarTitle}>Zarul a căzut pe caseta cu nr. 3</Typography>
                                    <Typography className={styles.zarText}>Tradu mesajul GOATY - There is always room for one more!Așează cuvintele în ordinea corectă.</Typography>
                                </Grid>

                                <Grid item xs={12} lg={6} className={styles.boxZar}>
                                    <img src={imgZar4} alt={'imgZar4'} className={styles.imgZar}/>
                                    <Typography className={styles.zarTitle}>Zarul a căzut pe caseta cu nr. 4</Typography>
                                    <Typography className={styles.zarText}>Ordonează halbele de bere în funcție de cantitate - de la cea mai mică la cea mai mare!</Typography>
                                </Grid>

                                <Grid item xs={12} lg={6} className={styles.boxZar}>
                                    <img src={imgZar5} alt={'imgZar5'} className={styles.imgZar}/>
                                    <Typography className={styles.zarTitle}>Zarul a căzut pe caseta cu nr. 5</Typography>
                                    <Typography className={styles.zarText}>Rezolvă puzzle-ul cu cuvinte încrucișate și află mesajul ȚAPĂN!</Typography>
                                </Grid>

                                <Grid item xs={12} lg={6} className={styles.boxZar}>
                                    <img src={imgZar6} alt={'imgZar6'} className={styles.imgZar}/>
                                    <Typography className={styles.zarTitle}>Zarul a căzut pe caseta cu nr. 6</Typography>
                                    <Typography className={styles.zarText}>NOROCOSULE!</Typography>
                                    <Typography className={styles.zarText}>Ai finalizat provocările! Mergi direct la Premiu :)</Typography>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </TeaserFrame2>
            </Grid>
            <Grid item xs={12} lg={4}>
                <Typography className={styles.prizesText}>Solving the third challenge brings 50 points to your group on kozel.ro</Typography>
            </Grid>
            <Grid item xs={12} lg={4}>
                <Typography className={styles.recommendGroupText}>Make sure you have your group formed - go to the
                    &nbsp;<NavLink to={paths.myGroup}>My Group</NavLink> section and invite your friends to the Kozel Meeet community!</Typography>
            </Grid>
        </Grid>
    )
}

export default Challenge3;